export const claimRecordConfig = {
    hideContributorLinking: [
        130, // Book Chapter
        177, // Conference Paper
        179, // Journal Article
    ],
};
